import { Page } from '@/components/Page'

export interface DashboardPageProps {}

export const DashboardPage: React.FC<DashboardPageProps> = ({}) => {
  return <Page metadata={{ title: 'Dashboard' }}></Page>
}
